module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_null@2x.373856ff.png";